export const enum FieldName {
  Company = 'company',
  VatNumber = 'vatNumber',
  Title = 'title',
  FirstName = 'firstName',
  LastName = 'lastName',
  EmailAddress = 'emailAddress',
  Password = 'password',
  NewsletterSubscription = 'newsletterSubscription',
  HomeClubSubscription = 'homeClubSubscription',
  UserType = 'userType',
}
